<template>
  <div class="AddRfDevice lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddRfDevice-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddRfDevice-main lxn-pos-rel">
      <div class="AddRfDevice-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddRfDevice_title1}}
          </template>
          <template v-slot:body>
            <div class="AddRfDevice-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddRfDevice_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="DeviceName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddRfDevice_namePlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddRfDevice_title2}}
          </template>
          <template v-slot:body>
            <div class="AddRfDevice-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddRfDevice_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetDeviceType" :dropDownContex="dropDownTargetDeviceTypes" />
            </div>
            <div class="AddRfDevice-wrapper-fieldText lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddRfDevice_text3}}
            </div>
            <div class="AddRfDevice-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="pairDevice" bgColor="#1EA5DE" iconRight="pair" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddRfDevice_testDevice}}
              </CustomButton>
            </div>
            <div class="AddRfDevice-wrapper-fieldText lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddRfDevice_text4}}
            </div>
            <div class="IrDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="testChannel(0)" bgColor="#1EA5DE" iconRight="test" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddRfDevice_testChannel1}}
              </CustomButton>
            </div>
            <div class="IrDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="testChannel(1)" bgColor="#1EA5DE" iconRight="test" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddRfDevice_testChannel2}}
              </CustomButton>
            </div>
            <div class="IrDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="testChannel(2)" bgColor="#1EA5DE" iconRight="test" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddRfDevice_testChannel3}}
              </CustomButton>
            </div>
            <div class="IrDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="testChannel(3)" bgColor="#1EA5DE" iconRight="test" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddRfDevice_testChannel4}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="AddRfDevice-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddRfDevice_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE8 from '@/statics/devices/Node8/header.js'

export default {
  name: 'AddRfDevice',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
  },
  data: function () {
    return {
      DeviceName: '',
      input1State: '',
      targetDeviceType: 0,
      targetBrand: 0,
      targetModel: 0,
    }
  },
  mounted: function () {
  },
  watch: {
    targetDeviceType: function (){
      this.targetBrand = 0;
      this.targetModel = 0;
    },
    targetBrand: function (){
      this.targetModel = 0;
    },
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    node: function () {
      return this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    },
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    dropDownTargetDeviceTypes: function () {
      var dropDownTargetDeviceTypes = {
        name: "AddRfDevice-TargetDeviceTypes",
        title: this.$store.getters.language.texts.AddRfDevice_text2,
        selectedIndex: this.targetDeviceType,
        data: []
      };
      for(var i = 0; i < NODE8.devices.length; i++){
        dropDownTargetDeviceTypes.data.push({
          name: NODE8.devices[i].name,
          icon: NODE8.devices[i].icon,
        })
      }
      return dropDownTargetDeviceTypes;
    },
    targetDevice: function () {
      return NODE8.devices[this.targetDeviceType];
    },
    randomDeviceId: function () {
      var deviceId = [];
      for(var i = 0; i < this.targetDevice.idLength; i++){
        deviceId.push((Math.random() > 0.5)? 1 : 0);
      }
      return deviceId;
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    pairDevice: function () {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      var learnPacket = [...this.randomDeviceId, ...this.targetDevice.learnPacket];
      var endSeq = [0, 0];
      if(this.targetDevice.endThrUs != 0){
        endSeq = [this.targetDevice.beforeEnd ? this.targetDevice.highThrUs : this.targetDevice.lowThrUs, this.targetDevice.endThrUs];
      }
      var rfPacket = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(learnPacket, this.targetDevice.lowThrUs, this.targetDevice.highThrUs, this.targetDevice.startSeq, endSeq));

      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.node.uuid,
              actions: [
                {
                  parameterId: NODE8.RF.PARAMETER_ID,
                  valueOfChange: messagingHook.utility.arrayTo64(rfPacket),
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  timeDelay: 0
                }
              ]
            },
          ]
        }
      })
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      });
    },
    testChannel: function (channel) {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      var endSeq = [0, 0];
      if(this.targetDevice.endThrUs != 0){
        endSeq = [this.targetDevice.highThrUs, this.targetDevice.endThrUs];
      }
      var channelPacket = [...this.randomDeviceId, ...this.targetDevice.channels[channel]];

      var rfPacket = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(channelPacket, this.targetDevice.lowThrUs, this.targetDevice.highThrUs, this.targetDevice.startSeq, endSeq));

      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.node.uuid,
              actions: [
                {
                  parameterId: NODE8.RF.PARAMETER_ID,
                  valueOfChange: messagingHook.utility.arrayTo64(rfPacket),
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  timeDelay: 0
                }
              ]
            },
          ]
        }
      })
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      });
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.DeviceName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddRfDevice_alert1);
      }else{
        var endSeq = [0, 0];
        if(this.targetDevice.endThrUs != 0){
          endSeq = [this.targetDevice.highThrUs, this.targetDevice.endThrUs];
        }
        var rfCommands = [];
        var messagingHook = new Messaging(new Logger(false));
        for(var i = 0; i < 4; i++){
          rfCommands.push(messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData([...this.randomDeviceId, ...this.targetDevice.channels[i]], this.targetDevice.lowThrUs, this.targetDevice.highThrUs, this.targetDevice.startSeq, endSeq)));
        }

        this.$store.commit('setAppBusy', true);
        this.$store.commit('addOutputToDevice', {
          nodeIndex: this.node.index,
          output: {
            icon: NODE8.devices[this.targetDeviceType].icon,
            name: this.DeviceName,
            parameterId: NODE8.RF.PARAMETER_ID,
            type: 'RfDevice',
            settings: {
              deviceId: this.randomDeviceId,
              deviceType: this.targetDeviceType,
              rfCommands: rfCommands,
            }
          }
        });
        this.$store.commit('saveState');
        this.$router.push('/home/devices/');
        this.$store.commit('setAppBusy', false);
      }
    },
  }
}
</script>

<style>
  .AddRfDevice-topCurve-wrapper {
    height: 200px;
  }
  .AddRfDevice-main {
    z-index: 2;
  }
  .AddRfDevice-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddRfDevice-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddRfDevice-wrapper-colors {
    height: 50px;
  }
  .AddRfDevice-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddRfDevice-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddRfDevice-color.active .AddRfDevice-selectedColor {
    opacity: 1;
  }
  .AddRfDevice-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddRfDevice-wrapper-name-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddRfDevice-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddRfDevice-wrapper-fieldText {
    margin-top: 14px;
    line-height: 20px;
    color: #52626C;
  }
  .AddRfDevice-wrapper-button {
    width: calc(100% - 36px);
    margin-top: 15px;
    margin-bottom: 14px;
  }
  .AddRfDevice-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .AddRfDevice-wrapper-commands:first-child {
    margin-top: 0;
  }
  .AddRfDevice-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddRfDevice-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
